import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changeBagLabelValue = createAction('CHANGE_BAGLABEL_VALUE');

export const cleanBagLabelAlert = createAction('CLEAN_BAGLABEL_ALERT');

export const generateBagLabel = (bagLabel) => (
  (dispatch) => {

    dispatch({
      type: 'BEFORE_GENERATE_BAGLABEL'
    });

    let url = '/firefighter/baglabel/generate';
    authFetch('POST', url, JSON.stringify(bagLabel), (json) => {
      dispatch({
        type: 'AFTER_GENERATE_BAGLABEL',
        payload: json
      });
    });
  }
);

export const generateBagLabel2 = (bagLabel) => (
  (dispatch) => {

    dispatch({
      type: 'BEFORE_GENERATE_BAGLABEL'
    });

    let url = '/firefighter/baglabel/generateItemLabel';
    authFetch('POST', url, JSON.stringify(bagLabel), (json) => {
      dispatch({
        type: 'AFTER_GENERATE_BAGLABEL',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/bagLabelActions.js